//import { Articulo } from '../articulo/articulo.interface';

export class ArtGaleria{// implements Articulo{
	id;
	idArt;
	pagina;
	galeria;
	categoriaArticulo;
	fechModificado;
	usrModificado;

	constructor(
		id=false,
		idArt=false,
		pagina=false,
		categoriaArticulo=false,
		galeria=false,
		fechModificado=false,
		usrModificado=false
		){
		this.id = id;
		this.idArt = idArt;
		this.pagina = pagina;
		this.categoriaArticulo = categoriaArticulo;
		this.fechModificado = fechModificado;
		this.usrModificado = usrModificado;
		this.galeria = galeria;
	}

	setCategoriaArticulo(categoriaArticulo){
		this.categoriaArticulo = categoriaArticulo;
	}
}
